/** DGC Wallet / RWAX 下载链接（可由 stack-config → VITE_* 注入） */

function viteEnv(name: string, fallback: string): string {
	const v = import.meta.env[name];
	return typeof v === 'string' && v.length > 0 ? v : fallback;
}

/** DGC Wallet Android APK（本地下载服 / download.dgclabs.cc） */
export const WALLET_APK_URL = viteEnv(
	'VITE_CPC_WALLET_APK_URL',
	'https://download.dgclabs.cc/dgc-wallet.apk',
);

/** DGC Wallet 公网备用下载 */
export const WALLET_APK_MIRROR_URL = viteEnv(
	'VITE_CPC_WALLET_APK_MIRROR_URL',
	'https://download.dgclabs.cc/dgc-wallet.apk',
);

export const WALLET_EXTENSION_URL = viteEnv(
	'VITE_CPC_WALLET_EXTENSION_URL',
	'https://download.dgclabs.cc/dgc-wallet-extension-dist.zip',
);

/** RWAX 超级 App — 主下载（手波安装页） */
export const RWAX_APP_URL = viteEnv(
	'VITE_RWAX_APP_URL',
	'https://app.shoubo.net/app.php/NA==',
);

/** RWAX 备用下载（直链 APK） */
export const RWAX_APP_MIRROR_URL = viteEnv(
	'VITE_RWAX_APP_MIRROR_URL',
	'https://download.dgclabs.cc/rwax.apk',
);

/** RWAX iOS 超级签名 / 扫码安装页 */
export const RWAX_IOS_APP_URL = viteEnv(
	'VITE_RWAX_IOS_APP_URL',
	'https://ytg0o.scnjgb.com/u8PEwvJ/1EnhpWdIZgrwZMOFT',
);
